// The settlement a cost's drawer was opened from: the wizard's summary
// opens a cost in the same drawer as the cost list (Lewis, 2026-10-19), and
// the drawer then shows how that settlement splits the cost, as the popup
// did. The drawer opens through the URL (`propertyCostId`, DetailDrawers),
// which cannot carry the settlement's figures: the summary leaves them here
// right before it opens the drawer, and takes them back when it unmounts.
// The drawer uses them for that cost only; opened any other way (the cost
// list, a link, a reload) it finds none and shows the cost alone.
import { useSyncExternalStore } from "react";
import type {
  ICostShareContext,
  ICostSplitParty,
} from "./scenes/SettlementInfo/SettlementForm/steps/costShareCalculation.utils";

export interface ICostDrawerSplit {
  invoiceId: string;
  splitContext: ICostShareContext;
  settlementName?: string;
  // The summary row that opened the cost: its party is tinted in the split.
  openedFor?: ICostSplitParty;
}

let current: ICostDrawerSplit | undefined;
const listeners = new Set<() => void>();

export const setCostDrawerSplit = (next?: ICostDrawerSplit) => {
  current = next;
  listeners.forEach(listener => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

const getSnapshot = () => current;

// The settlement's split of this cost, when the drawer was opened from it.
export const useCostDrawerSplit = (
  invoiceId?: string,
): ICostDrawerSplit | undefined => {
  const split = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return split && invoiceId != null && split.invoiceId === invoiceId
    ? split
    : undefined;
};
